import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { PhoneFilled, WhatsAppOutlined } from "@ant-design/icons";

import "./sticky-book-cta.component.styles.scss";
import {
  PHONE_TEL,
  WHATSAPP_URL,
  conversions,
} from "../../../lib/analytics";
import { resolveServiceId } from "../../../content/booking-catalog";
import { useLang, stripLangPrefix } from "../../../lib/i18n";

// Floating mobile conversion dock: Prenota pill + phone icon + WhatsApp icon.
// Hides on /booking and /contact (where equivalent CTAs already dominate the page),
// and only appears after a short scroll so it doesn't fight the hero.
const HIDE_ON = new Set(["/booking", "/contact"]);

const StickyBookCta: React.FC = () => {
  const { pathname } = useLocation();
  const { lang, lp } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  const cleanPath = stripLangPrefix(pathname);
  if (HIDE_ON.has(cleanPath)) return null;
  const isEn = lang === "en";

  // On a service landing page, carry the treatment into the booking wizard.
  const slug = cleanPath.replace(/^\//, "");
  const bookTo = resolveServiceId(slug)
    ? `/booking?treatment=${slug}`
    : "/booking";

  return (
    <div
      className={`lvs-stickycta${visible ? " is-visible" : ""}`}
      role="complementary"
      aria-label={isEn ? "Book or contact Laviens" : "Prenota o contatta Laviens"}
    >
      <Link
        to={lp(bookTo)}
        className="lvs-stickycta__book"
        onClick={() => conversions.book("sticky_mobile", slug || undefined)}
      >
        {isEn ? "Book" : "Prenota"}
      </Link>
      <a
        href={`tel:${PHONE_TEL}`}
        className="lvs-stickycta__icon lvs-stickycta__icon--call"
        aria-label={isEn ? "Call Laviens" : "Chiama Laviens"}
        onClick={() => conversions.phone("sticky_mobile")}
      >
        <PhoneFilled />
      </a>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="lvs-stickycta__wa"
        aria-label={isEn ? "Message on WhatsApp" : "Scrivi su WhatsApp"}
        onClick={() => conversions.whatsapp("sticky_mobile")}
      >
        <WhatsAppOutlined />
        <span>WhatsApp</span>
      </a>
    </div>
  );
};

export default StickyBookCta;
